import { RootState } from '../store';

export const selectModal = (state: RootState) => state.modal;
